import React, { FC, Ref } from 'react'
import styled, { css } from 'styled-components'

import {
  backgroundColor,
  complementaryColor,
  darkGrayColor,
  primaryColor,
  saleAlternativeColor,
} from 'uiComponents/constants/colors'
import {
  fontFamilyPrimary,
  fsXS,
  fwMediumBold,
} from 'uiComponents/constants/typography'

import Ripple from '../Ripple/Ripple'

const Container = styled.button`
  display: inline-flex;
  cursor: pointer;
  background: ${backgroundColor};
`

const StyledRipple = styled(Ripple)<Partial<QuickFilterSquareProps>>`
  border-radius: 2px;
  padding: 1px 10px 2px;
  line-height: 23px;
  opacity: 0.8;
  ${fontFamilyPrimary};
  font-size: ${fsXS}px;
  ${fwMediumBold};
  letter-spacing: 0.14px;
  color: ${darkGrayColor};
  box-sizing: content-box;
  text-transform: capitalize;
  border: 1px solid ${complementaryColor};

  ${({ selected, sale }) =>
    selected &&
    !sale &&
    css`
      border: 1px solid ${primaryColor};
      color: ${primaryColor};
      background-color: ${complementaryColor};
    `};

  ${({ sale }) =>
    sale &&
    css`
      background-color: ${complementaryColor};
      color: ${saleAlternativeColor};
      border: 1px solid ${saleAlternativeColor};
    `};
`

export interface QuickFilterSquareType {
  id: string
  title: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  selected: boolean
}

interface QuickFilterSquareProps extends QuickFilterSquareType {
  ref?: Ref<HTMLButtonElement>
  className?: string
}

const QuickFilterSquare: FC<QuickFilterSquareProps> = ({
  id,
  className,
  title,
  onClick,
  selected,
}) => {
  const dataTestId = `quickFilter_${selected ? 'selected' : 'unselected'}_${id}`

  return (
    <Container onClick={onClick} className={className}>
      <StyledRipple data-testid={dataTestId} selected={selected}>
        {title}
      </StyledRipple>
    </Container>
  )
}

export default QuickFilterSquare
